import { useQuery } from '@tanstack/react-query';
import type {
	MaintenancePreviewDemandResponse,
	MaintenanceStartPayload,
} from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function useGetAdviceMaintenancePreviewDemand(payload: MaintenanceStartPayload | null) {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['maintenance', 'preview-demand', forBinding, payload],
		enabled: !!payload,
		retry: false,
		queryFn: async () => {
			try {
				const { data } = await api.post<MaintenancePreviewDemandResponse>(
					'/advices/fertilization-plan/preview-demand',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao gerar a prévia da demanda');
			}
		},
	});
}
